import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "blog-text" }
const _hoisted_2 = { class: "blog-title" }
const _hoisted_3 = { class: "blog-excerpt" }
const _hoisted_4 = { class: "blog-footer" }
const _hoisted_5 = {
  key: 0,
  class: "blog-image-wrapper"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "card card--tip"
}
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "tip" }

import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';
import { useTipStore } from '@/store/tipStore';
import blogService from '@/services/blogService';
import type { BlogResponse } from '@/types/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'AstuceJourWidget',
  setup(__props) {

const { t, locale } = useI18n();
const userStore = UseStoreUser();
const tipStore = useTipStore();
const blogs = ref<BlogResponse[]>([]);
let loading = false;

function loadBlogs() {
  loading = true;
  const lang = locale.value?.slice(0, 2) || 'fr';
  blogService.getLatestBlog(lang).then(result => {
    blogs.value = result ? [result] : [];
    //TODO: remove if tips are no longer displayed
    if (!blogs.value.length) {
      tipStore.loadRandomTip(userStore.userApps.map(app => app.label));
    }
    loading = false;
  });
}

tipStore.setLanguage(locale.value);
loadBlogs();

watch(
  () => locale.value,
  (newLocale) => {
    if (loading) return;
    tipStore.setLanguage(newLocale);
    const lang = newLocale?.slice(0, 2) || 'fr';
    if (blogs.value.length > 0) {
      blogService.getBlogById(blogs.value[0].id, lang).then(result => {
        if (result) blogs.value = [result];
      });
    } else {
      loadBlogs();
    }
  }
);

function formatDate(dateStr: string | null): string {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return new Intl.DateTimeFormat(locale.value || 'fr', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(d);
}

function todayKey(): string {
  const today = new Date();
  return new Intl.DateTimeFormat(locale.value, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(today);
}

return (_ctx: any,_cache: any) => {
  const _component_cs_link = _resolveComponent("cs-link")!
  const _component_cs_widget = _resolveComponent("cs-widget")!

  return (_openBlock(), _createBlock(_component_cs_widget, {
    title: _unref(t)('dashboard.blog')
  }, {
    default: _withCtx(() => [
      (blogs.value.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(blogs.value, (blog) => {
            return (_openBlock(), _createElementBlock("div", {
              key: blog.id,
              class: _normalizeClass(['card', { 'card--no-image': !blog.imageBase64 }])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h4", _hoisted_2, _toDisplayString(blog.title), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(blog.excerpt), 1),
                _createElementVNode("div", _hoisted_4, [
                  (blog.link)
                    ? (_openBlock(), _createBlock(_component_cs_link, {
                        key: 0,
                        link: blog.link,
                        "is-external-link": "",
                        target: "_blank",
                        class: "see-more",
                        "aria-label": _unref(t)('dashboard.seeMore')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('dashboard.seeMore')), 1)
                        ]),
                        _: 1
                      }, 8, ["link", "aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (blog.imageBase64)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: blog.imageBase64,
                      alt: "",
                      class: "blog-image"
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(todayKey()), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(tipStore).tip?.product_label || ''), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(tipStore).tipBody), 1)
          ]))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})